import { get } from "lodash";
import { useUserPerson } from "src/contexts/global/GlobalContext";
import { getDefaultRoutePath } from "src/util/routing";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";
import { useOrgDesignBetaEnabled } from "src/components/OrgChart/controller/dnd/featureFlags";
import useRestricted from "./useRestricted";

const useDefaultRoutePath = () => {
  const [isRestricted] = useRestricted();
  const userPerson = useUserPerson();
  const { disablePersonalisation } = useWorkspaceFeatureFlags();
  const isOrgDesignBetaEnabled = useOrgDesignBetaEnabled();

  const userId = disablePersonalisation ? null : get(userPerson, "aggregateId");
  // Independent of disablePersonalisation, unlike `userId` above - matches
  // the raw "has a Person record" signal getRoutes gates ORG_DESIGN_HOME on.
  const hasPerson = Boolean(get(userPerson, "aggregateId"));

  const defaultRoutePath = getDefaultRoutePath({
    userId,
    hasPerson,
    isRestricted,
    isOrgDesignBetaEnabled,
  });

  return defaultRoutePath;
};

export default useDefaultRoutePath;
